export default "__VITE_ASSET__W6s08oBo__"